import apiClient from './apiClient';

export const getImages = (params) => apiClient.get('/image', { params });
export const deleteImage = (id) => apiClient.delete(`/images/${id}`);